import { useKestrelViewerContext } from 'features/kestrelViewer'
import { fadeIn } from 'features/kestrelViewer/ui/popupMenu/shared/SharedModalComponents'
import omit from 'lodash/omit'
import React from 'react'
import styled from 'styled-components'

import { PhotoReelContent } from './carousel/PhotoReelContent'
import { PhotoReelHeader } from './carousel/PhotoReelHeader'

const CarouselContainer = styled.div`
  position: absolute;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-25vw);
  width: 50vw;
  background-color: ${({ theme }) => theme.forecast.background2};
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  animation: ${fadeIn} 0.3s ease-in;
  z-index: 1000;
`

export const PhotoReelCarousel: React.FC = () => {
  const {
    photoReelOpen,
    setSelectedPhoto,
    photos,
    setPhotos,
    filteredPhotos,
    setFilteredPhotos,
    photosLoading,
    photosError,
  } = useKestrelViewerContext()

  // Use filtered photos if available, otherwise use all photos
  const displayPhotos = filteredPhotos || photos

  // Only render when photo reel is open
  if (!photoReelOpen) return null
  const isFiltered = filteredPhotos !== null

  const handlePhotoClick = (imageId: string) => {
    // Find the photo and set it as selected
    const photo = displayPhotos.find((p) => p.id === imageId)
    if (photo) {
      setSelectedPhoto(photo)
    }
  }

  const handleClearFilter = () => {
    setFilteredPhotos(null)
    const clearedPhotos = photos.map((photo) => omit(photo, 'projection'))
    setPhotos(clearedPhotos)
  }

  return (
    <>
      <CarouselContainer>
        <PhotoReelHeader
          photoCount={displayPhotos.length}
          totalPhotoCount={photos.length}
          isFiltered={isFiltered}
          onClearFilter={handleClearFilter}
        />
        <PhotoReelContent
          photos={displayPhotos}
          isLoading={photosLoading}
          error={photosError}
          onPhotoClick={handlePhotoClick}
        />
      </CarouselContainer>
    </>
  )
}
